import React, { useEffect, useState } from "react";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import greatSoulImg from "../../assets/images/the-great-souls/png/temple_the_great_souls.png";
import greatDecorate from "../../assets/images/coursesPage/LordGaveBapu/png/bapuBgDecorate.png";
import orangeTick from "../../assets/images/svg/orenge_tick.svg";
import Button from "../common/button/Button";
import CommonHeading from "../common/heading/CommonHeading";
import { ModalList } from "../../utils/TheGreateSageHelper";
import Modal from "../common/modal/Modal";
import { greateSageList } from "../../utils/TheGreateSageHelper";
const TheGreatSage = () => {
  const [popupOpen, setPopupOpen] = useState(null);

  function showPopup(index) {
    setPopupOpen(popupOpen === index ? null : index);
  }

  const isModalOpen = popupOpen !== null;
  useEffect(() => {
    if (isModalOpen) {
      document.getElementById("html").classList.add("overflow-hidden");
    } else {
      document.getElementById("html").classList.remove("overflow-hidden");
    }

    // Cleanup on component unmount
    return () => {
      document.getElementById("html").classList.remove("overflow-hidden");
    };
  }, [isModalOpen]);
  return (
    <>
      <div className="position-relative great_souls pt-2">
        {/*<img
          className="position-absolute bottom_flower_mahamantra end-0 maharaj_top z_index_n2"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/} 
        <img
          src={greatSoulImg}
          className="w-25 position-absolute start-0"
          style={{ bottom: "-10%" }}
          alt="temple_the_great_souls"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute start-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute end-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        {/*<img
          className="position-absolute top_flower_mahamantra souls_top_flower start-0 the_great_flower"
          src={topFlowerImg}
          alt="top_flower"
        />*/}

        <div className="container_modified container position-relative mt-0 pt-3 pt-sm-4">
          <div className="row justify-content-center mt-xl-2">
            <div className="col-lg-11 text-center mb-4 pb-lg-2">
              <CommonHeading
                heading="The Finest Ashram In Rishikesh"
                className="text-orange common_heading_text common_heading_text_brown"
              />
              <h2 className="common_sub_heading text-center mb-1 mb-md-3 px-4 px-md-0">
                TRIMURTI SEVA ASHRAM
              </h2>
            </div>
          </div>
          <div className="row justify-content-between mb-3 pb-3">
            <div className="col-lg-12">
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-5">
                  Thirty years in the making, Trimurti Ashram not only reminds us of the time of the ancient Rishis (the seers for whom Rishikesh was named), but also serves as custodian to what ‘Bapu’ called “the safest, fastest, fullest path to life’s goal.”
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                The Great Sage said the he took a body “so that humanity would have something real.” Thus does Trimurti Ashram offer Sahaj Dhyan Yoga – the Yoga of Spontaneous Meditation, which from the first experience spontaneously brings on the state of meditation, coveted from time immemorial.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="nav_overlay position-fixed top-0 start-0 vh-100 w-100 z_index_4"
          onClick={() => setPopupOpen(null)}
        ></div>
      )}
      {isModalOpen && (
        <Modal
          data={ModalList[popupOpen]}
          showPopup={() => setPopupOpen(null)}
        />
      )}
    </>
  );
};

export default TheGreatSage;
